import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./context/CartContext";
import { AppDataProvider } from "./context/AppDataContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import type { ReactNode } from "react";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AuthenticatedDataProviders>
            <AppRoutes />
          </AuthenticatedDataProviders>
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

function AuthenticatedDataProviders({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (!user || user.mustChangePassword) return children;
  return <AppDataProvider><CartProvider>{children}</CartProvider></AppDataProvider>;
}

export default App;
